// src/components/pages/portfolios/partials/PortfolioCurrentComposition.js (신규 파일)

import React, { useMemo } from 'react';
import {
  ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, Legend
} from 'recharts';
import styles from './../style/PortfolioDetail.module.css';

export default function PortfolioCurrentComposition({ timeSeries, t }) {
  const compositionHistory = timeSeries?.compositionHistory || [];
  
  const compTickers = useMemo(() => {
    const set = new Set();
    compositionHistory.forEach(row => Object.keys(row).forEach(k => { if (k !== 'date') set.add(k); }));
    return [...set];
  }, [compositionHistory]);

  const lastComp = compositionHistory[compositionHistory.length - 1] || {};
  const sortedData = compTickers
    .map(ticker => ({ ticker, weight: lastComp[ticker] ?? 0 }))
    .filter(d => d.weight > 0)
    .sort((a, b) => b.weight - a.weight);

  if (compositionHistory.length === 0) return null;

  return (
    <div className={styles.chartBlock}>
      <h3 className={styles.subTitle}>{t('portfolioDetail.compositionTitle')}</h3>
      <ResponsiveContainer width="100%" height={sortedData.length * 40 + 50}>
        <BarChart data={sortedData} layout="vertical" margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis type="number" tickFormatter={v => `${(v * 100).toFixed(0)}%`} />
          <YAxis dataKey="ticker" type="category" width={80} />
          <Tooltip formatter={v => `${(v * 100).toFixed(2)}%`} />
          <Legend />
          <Bar dataKey="weight" fill="#8884d8" barSize={20} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}